<template>
  <div class="seat"
       :class="{'reserved' : !isFree, 'selected': checkIsSelected}"
       :style="'grid-row:' + row + '; grid-column:' + col + ';'"
       @click="onSelectSeat">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Seat',
  props: [ 'col', 'row', 'seatId', 'isFree', 'type' ],
  computed: {
    checkIsSelected () {
      return this.$store.state.selectedSeatSet.has(this.seatId)
    }
  },
  methods: {
    onSelectSeat () {
      if (this.isFree) {
        this.$store.dispatch('selectSeat', this.seatId)
      }
    }
  }
}
</script>

<style scoped>
.seat {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #252525;
  color: #FFF;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: .2s;
  user-select: none;
  width: 80px;
}

.seat:nth-last-child(-n+7) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.seat:nth-child(n+25):nth-child(-n+30) {
  position: absolute;
  width: 100px;
  height: 80px;
  left: -10px;
  border-radius: 16px;
}

.seat:nth-child(-n+25) {
  border-radius: 8px;
}

.seat:hover {
  background-color: var(--beel-primary);
  transition: .2s;
}

.seat.reserved:hover {
  background-color: #D0D5DD;
  transition: .2s;
}

.reserved {
  background-color: #D0D5DD;
  transition: .2s;
  cursor: default;
}

.seat.selected {
  background-color: var(--beel-primary);
  transition: .2s;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Seat.vue